import Reflux from 'reflux';
import NProgress from 'nprogress';
import http from '../../helper/ajax';

const FilterAction = Reflux.createActions([
  'pushForFilter',
  'publishNewData',
]);

NProgress.configure({ easing: 'ease', speed: 500 });

FilterAction.pushForFilter.preEmit = (data) => {
  NProgress.start();
  jQuery('#LoadTime').fadeIn(300);
  http.post('filter_data', data).end((error, res) => {
    if (res) {
      NProgress.done();
      jQuery('#LoadTime').fadeOut(300);
      FilterAction.publishNewData(JSON.parse(res.text));
    }
  });
};

export default FilterAction;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/action/filterAction.js
 **/